














































  import {computed, defineComponent, onBeforeMount, reactive, toRefs, watch} from '@vue/composition-api'

  import {ServiceFactory} from '@/service/ServiceFactory'
  import {useStore} from '@/utils/use-store'
  import {Exercise, Practice} from '@/helpers/types'

  export default defineComponent({
  name: 'ConnectItems',

  props: {
    instanceName: {
      type: String,
      required: true,
    },
    source: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    categories: {
      type: Array,
      default: () => [],
    },
    isOpen: {
      type: Boolean,
      default: () => false,
    },
    parentSelected: {
      type: Array,
      default: () => [],
    }
  },

  setup: function (props, { refs, emit }) {
    const store = useStore();
    const {accessToken: token} = store.state.user;
    const instance = ServiceFactory.get(props.instanceName);
    const state = reactive({
      items: [] as any[],
      selected: [] as any[],
      category: null,
    });

    onBeforeMount(onBeforeMountEventHandler)

    /**
     * Handler for onBeforeMount event
     * */
    async function onBeforeMountEventHandler() {
      await fetch()
    }

    /**
     * Fetch items from API
     * */
    async function fetch() {
      try {
        let params = '';
        if (props.instanceName === 'exercise') {
          params = '?take=0';
        }
        const {data} = await instance.list(token, params);
        state.items = data
      } catch (e) {
        const message: string = e.response ? e.response.data.message || e.response.data.error : e.message
        throw Error(message)
      }
    }

    /**
     * Generate text for item
     * @param {any} item
     * @return {string} text
     * */
    function generateText(item: any): string {
      return item.summary || item.name
    }

    /**
     * Handler for autocomplete change event
     * @param {number} id
     * */
    function autocompleteChangeEvent(id: number): void {
      const autocomplete: any = refs['connect-autocomplete'];
      autocomplete.blur();
      autocomplete.reset();
      state.selected = [...new Set([...state.selected, state.items.find((item: any): any => item.id === id)])];
      state.items = state.items.filter(item => !state.selected.some(s => s.id === item.id));
    }

    /**
     * Handler for remove question event
     * @param {any} item
     * */
    function removeQuestion(item: any) {
      state.items = [item, ...state.items];
      state.selected = state.selected.filter(s => s.id !== item.id);
    }

    watch(() => state.selected, (selected) => {
      emit('changed', selected);
    });

    watch(() => props.isOpen, (value) => {
      if (!value) {
        state.category = null;
      }
    });

    const filteredItems = computed(() => state.category ? state.items.filter(item => item.practice?.category.id === state.category) : state.items);
    watch(() => state.category, (value) => {
      state.items = [...state.items, state.selected];
      state.selected = props.parentSelected.length && (props.parentSelected[0] as Exercise).practice?.category.id === value ? props.parentSelected : [];
    });

    watch(() => props.parentSelected, (value) => {
      if (value.length) {
        const parentCategory: any = (value as Exercise[]).map((item: Exercise): Practice | null => item.practice)[0]?.category.id;
        state.category = parentCategory;
      }
    });

    return {
      ...toRefs(state),
      filteredItems,
      generateText,
      autocompleteChangeEvent,
      removeQuestion,
    }
  },
})
